import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Anchor, Box, xcss } from '@atlaskit/primitives';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import { IPHAnchor } from '@atlassian/eoc-iph-store';

import messages from '../../../../common/messages';
import { OptionalSupportUrlKeys, SupportUrlKeys } from '../../../../common/types';
import { useHeartbeatsContext } from '../../../../controllers/providers/heartbeats';

const ContainerStyles = xcss({ maxWidth: '950px' });

export const Description = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { supportUrls } = useHeartbeatsContext();
	const heartbeatsAPIUrl = supportUrls[SupportUrlKeys.HEARTBEATS_API];
	const whatAreHeartbeatsUrl = supportUrls[OptionalSupportUrlKeys.WHAT_ARE_HEARTBEATS];

	return (
		<Box xcss={ContainerStyles}>
			<FormattedMessage
				{...messages.description}
				values={{
					linkRestApi: (msg: React.ReactNode) => (
						<Anchor href={heartbeatsAPIUrl} target="_blank" rel="noopener noreferrer">
							{msg}
						</Anchor>
					),
					linkReadMore: (msg: React.ReactNode) =>
						whatAreHeartbeatsUrl ? (
							<Anchor
								href={whatAreHeartbeatsUrl}
								target="_blank"
								rel="noopener noreferrer"
								onClick={(e) => {
									e.stopPropagation();
									const event = createAnalyticsEvent({});
									fireUIAnalytics(event, 'link clicked', 'learnMore');
								}}
							>
								{msg}
							</Anchor>
						) : (
							<IPHAnchor
								id="heartbeats-list-description"
								requiresDot
								onClick={(e) => {
									e.stopPropagation();
									const event = createAnalyticsEvent({});
									fireUIAnalytics(event, 'link clicked', 'learnMore');
								}}
							>
								{msg}
							</IPHAnchor>
						),
				}}
			/>
		</Box>
	);
};
